import { z } from "zod";

export const recordIdSchema = z.coerce.number().int().positive();
